// extracted by mini-css-extract-plugin
module.exports = {"richText":"content_area-module--rich-text--1G8MD","withPadding":"content_area-module--with-padding--_YNkU"};